import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'modern-css-reset/dist/reset.min.css'

Vue.config.productionTip = false

Vue.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

Vue.directive('interactable', (el, binding) => {
  el.style.pointerEvents = binding.value ? 'all' : 'none'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
